module.exports = __webpack_public_path__ + "img/T5-C-xs_3.d281ca62.png";